import React from "react";
import { cn } from "../../lib/utils";
import { Button } from "../ui/button";

export function FormActions({
  cancelLabel = "Cancel",
  submitLabel = "Save",
  onCancel,
  submitting = false,
  submitDisabled = false,
  className,
  submitTestId,
}) {
  return (
    <div
      className={cn(
        "flex flex-col-reverse gap-3 border-t border-[#242E42] pt-4 sm:flex-row sm:justify-end",
        className,
      )}
    >
      <Button
        type="button"
        variant="outline"
        onClick={onCancel}
        className="border-[#242E42] text-[#9CA3AF]"
      >
        {cancelLabel}
      </Button>
      <Button
        type="submit"
        disabled={submitting || submitDisabled}
        className="bg-[#E2B05E] text-[#0B0E14] hover:bg-[#F0C47A]"
        data-testid={submitTestId}
      >
        {submitLabel}
      </Button>
    </div>
  );
}

export default FormActions;
